import axios from "axios";

export default axios.create({
    baseURL:'https://api.unsplash.com',
    headers:{
        Authorization:'Client-ID uhQJBNmMIL4VhbVTZIkzSphiS64u_x5rc6F2WCyQm24'

    }
});